import {Icon} from '@/app/components/Icon';
import React, {useEffect, useState} from 'react';
import {Button} from '@/components/app/button';
import {useLazyGetSubConditionsQuery} from '../../../app/services/conditionApi';
import {Condition} from '../types';
export interface LeafConditionSelectorProps {
  condition: Condition;
  onSelect: (event: {condition: Condition}) => void;
  optional?: boolean;
}
export const LeafConditionSelector = ({condition, onSelect, optional = false}: LeafConditionSelectorProps) => {
  const [activeCondition, setActiveCondition] = useState(condition);
  const [subConditions, setSubConditions] = useState<Condition[]>([]);
  const [getSubConditions, {isFetching: isFetchingGetSubConditions}] = useLazyGetSubConditionsQuery();
  useEffect(() => {
    setActiveCondition(condition);
    getSubConditions({
      parentConditionId: condition.id,
    })
      .unwrap()
      .then(setSubConditions)
      .catch(console.error);
  }, [condition, getSubConditions]);
  return (
    <div>
      {!isFetchingGetSubConditions && subConditions.length > 0 && (
        <p className="m-0">
          Please select a subcondition of <strong>{activeCondition.conditionName}</strong>
          {optional ? ' ...' : '.'}
        </p>
      )}
      <div className="flex flex-wrap items-center gap-2 py-4">
        {isFetchingGetSubConditions && <Icon icon="spinner" spin />}
        {!isFetchingGetSubConditions &&
          subConditions.map((subCondition) => (
            <Button
              className="rounded-full text-sm p-2"
              key={subCondition.id}
              onClick={() => {
                getSubConditions({
                  parentConditionId: subCondition.id,
                })
                  .unwrap()
                  .then((result) => {
                    if (result.length === 0) {
                      onSelect({
                        condition: subCondition,
                      });
                    } else {
                      setActiveCondition(subCondition);
                      setSubConditions(result);
                    }
                  })
                  .catch(console.error);
              }}
              type="button"
            >
              {subCondition.conditionName}
            </Button>
          ))}
      </div>
      {optional && !isFetchingGetSubConditions && (
        <div className="flex items-center justify-end gap-2">
          ... or continue with
          <Button
            className="text-sm rounded-full"
            onClick={() =>
              onSelect({
                condition: activeCondition,
              })
            }
            type="button"
          >
            {activeCondition.conditionName}
          </Button>
        </div>
      )}
    </div>
  );
};
